import { useState, useEffect } from "react";

export default function CookieConsent() {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem("ss_cookie")) setShow(true); }, []);
  if (!show) return null;
  const choose = (v) => { localStorage.setItem("ss_cookie", v); setShow(false); };
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:max-w-md z-[55] bg-[#111113] border border-zinc-800 p-5" data-testid="cookie-consent">
      <p className="text-sm text-zinc-300 leading-relaxed">We use cookies to improve your experience and for analytics. Marketing pixels load only after you accept.</p>
      <div className="flex gap-2 mt-4">
        <button onClick={() => choose("all")} className="btn-accent px-4 py-2 text-xs font-bold uppercase tracking-wider" data-testid="cookie-accept-btn">Accept All</button>
        <button onClick={() => choose("essential")} className="border border-zinc-700 px-4 py-2 text-xs font-bold uppercase tracking-wider text-zinc-300 hover:border-zinc-500" data-testid="cookie-reject-btn">Reject Non-Essential</button>
      </div>
    </div>
  );
}
